import "./style/style.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Page from "./pages/Page.js";
import { useState } from "react";

function App() {
  const [transitionClass, setTransitionClass] = useState("");
  const [transitionEndBeep, setTransitionEndBeep] = useState(null); //changed to trigger child function
  const [backgroundColor, setBackgroundColour] = useState(null);
  const [textColour, setTextColour] = useState(null);

  const handleTransitionEnd = (event) => {
    if (event.target !== event.currentTarget) return;

    if (event.propertyName !== 'opacity') return;

    setTransitionEndBeep((prev) => {
      return !prev;
    })
  };

  const handleWorkColourChange = (colours) => {
    setBackgroundColour(colours.background ? colours.background : '#FFFFFF');
    document.querySelector('#root').style.backgroundColor = colours.background ? colours.background : '#FFFFFF';
    setTextColour(colours.text ? colours.text : '#000000');
  }

  const workPage = () => {
    return(
      <Page isWork={true} setAppTransitionClass={setTransitionClass} setAppWorkColours={handleWorkColourChange} onAppTransitionEnd={transitionEndBeep}/>
    )
  }

  return (
    <main
      id="app"
      className={transitionClass}
      onTransitionEnd={handleTransitionEnd}
      style={{backgroundColor: backgroundColor, color: textColour, fill: textColour}}
      //onAnimationEnd={handleTransitionEnd}
    >
      <BrowserRouter>
        <Routes>
          <Route
            path="/work/:slug"
            element={
              workPage()
            }
          />

          <Route
            path="/work"
            element={
              workPage()
            }
          />

          <Route
            path="/about"
            element={
              <Page isWork={false} setAppTransitionClass={setTransitionClass} onAppTransitionEnd={transitionEndBeep}/>
            }
          />

          <Route
            index
            element={
              workPage()
            }
          />
          
          <Route
            path="*"
            element={
              workPage()
            }
          />
        </Routes>
      </BrowserRouter>
    </main>
  );
}

export default App;